var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pest-faq-section" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.list, function(item, index) {
        return _vm.$route.params.id == item.id
          ? _c(
              "div",
              { key: index, staticClass: "faq-cell-wrapper mt30" },
              _vm._l(item.questions, function(titem, tindex) {
                return _c(
                  "div",
                  {
                    key: tindex,
                    staticClass: "faq-cell",
                    attrs: { id: "hotquestion_div_getHotQuesion_" + tindex },
                    on: {
                      click: function($event) {
                        return _vm.getHotQuesion($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "faq-cell-header flex-row",
                        attrs: { "data-fuget": titem.fuget_id }
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("@/assets/img/resources/plus-w-bold.svg")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "icon",
                          staticStyle: { display: "none" },
                          attrs: {
                            src: require("@/assets/img/resources/icon-minus-pink.svg")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "faq-cell-question" }, [
                          _vm._v(_vm._s(titem.question))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "faq-cell-answer" }, [
                      _c(
                        "p",
                        { staticStyle: { "line-height": "32px" } },
                        [
                          _vm._l(titem.answer, function(nitem, nindex) {
                            return [
                              _vm._v("\n          " + _vm._s(nitem)),
                              nindex != titem.answer.length - 1
                                ? _c("br")
                                : _vm._e()
                            ]
                          }),
                          _vm._v(" "),
                          titem.answer_list
                            ? [
                                _c("br"),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(titem.answer_list.title)
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _vm._l(titem.answer_list.list, function(
                                  citem,
                                  cindex
                                ) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(cindex + 1) +
                                        "." +
                                        _vm._s(citem)
                                    ),
                                    citem != titem.answer_list.list.length - 1
                                      ? _c("br")
                                      : _vm._e()
                                  ]
                                })
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cell-img-wrapper flex-row",
                          staticStyle: { "margin-top": "16px" }
                        },
                        _vm._l(titem.img_list, function(xitem, xindex) {
                          return _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: require("@/assets/img/resources/uploads/" +
                                  xitem),
                                expression:
                                  "require('@/assets/img/resources/uploads/' + xitem)"
                              }
                            ],
                            key: xindex,
                            staticClass: "pic mr10"
                          })
                        }),
                        0
                      )
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-h-center" }, [
      _c("div", { staticClass: "slash header mr10" }),
      _vm._v(" "),
      _c("div", { staticClass: "header-title purple-2" }, [_vm._v("热门问题")]),
      _vm._v(" "),
      _c("div", { staticClass: "slash header ml10" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17a5b8b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a5b8b0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hot_question.vue
// module id = null
// module chunks = 